export enum CheckBoxState {
    Undefined = -1,
    False = 0,
    True = 1
}
